import routeName from '../../../../routes/route-name';
import action from '../../../abstract/action';

export default action({
  label: 'Rozlicz',
  icon: 'ShoppingBagIcon',
  main: () => true,
  handle: async ({ $router, item }) => await $router.push({ name: routeName.bankingOperations.settle, params: { id: item.id } }),
});
